<nx-default-box class="bg-white border-b border-gray"
    [label]="'orderModule.refuelSumViewComponent.label' | translate">
    {{ sum !== null && sum !== undefined ? sum + ' l' : '—' }}
</nx-default-box>
